import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'

const OptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'name',
})

const getOptionLabel = (option) => option.name

const AssigneeFilter = ({ config }) => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()
    const queryParams = {
        trackingID: config?.trackingID,
        rtaLandscapeIdList:
            (Array.isArray(state?.landscapes) &&
                state?.landscapes?.map((landscape) => landscape.id)) ||
            [],
    }

    const filter = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('SelectAssignee')}
                url={config?.url}
                queryParams={queryParams}
                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={state.assigneeSelection ? state.assigneeSelection : null}
                optionComponent={OptionComponent}
                supportsServerSideSearch={false}
                minCharactersReqForSearch={0}
                clearIcon={
                    !isNilOrEmpty(state.assigneeSelection) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_PROP',
                                    payload: {
                                        key: 'assigneeSelection',
                                        value: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_PROP',
                        payload: {
                            key: 'assigneeSelection',
                            value: value,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('Assignee')}
            color="#fff"
            collapsible
            expanded={Boolean(state.assigneeSelection)}
        >
            {filter}
        </Card>
    )
}

export default AssigneeFilter
